<template>
  <div class="setNumCompute">
    <div class="contentItem">
      <div class="itemTitle">
        类型
        <span class="require-flag">*</span>
      </div>
      <div class="titleTip">计算类型，包括数值计算、时长计算和距离计算</div>
      <NormalSelect
        size="normal"
        class="item-select"
        :selectList="calcTypes.slice(0, 3)"
        :selectedItem.sync="tempNodeData.calcType"
        @handle-select="change"
      ></NormalSelect>
    </div>
    <div class="contentItem" v-if="tempNodeData.calcType === 'NUM'">
      <div class="itemTitle">
        计算表达式
        <span class="require-flag">*</span>
      </div>
      <group-dropdown-menu
        class="item-menu"
        v-if="canCalcFields.length"
        :width="width"
        :group-list="numWorkflowVarList"
        @select="selectCalcField"
      >
        <calc-textarea
          ref="calcTextarea"
          :control="tempNodeData"
          :canCalcFields="canCalcFields"
          :maxHeight="180"
          style="margin-bottom: 10px"
        ></calc-textarea>
      </group-dropdown-menu>
      <el-input
        class="item-select"
        v-else
        :disabled="true"
        placeholder="暂无可选字段，请添加节点"
      ></el-input>
    </div>
    <div class="contentItem" v-else>
      <div class="itemTitle" style="padding-bottom: 10px">
        计算表达式
        <span class="require-flag">*</span>
      </div>
      <tree-select v-model="tempNodeData.var1" :group-list="simpleWorkflowVarList"></tree-select>
      <span style="float: left; padding: 12px;">—</span>
      <tree-select v-model="tempNodeData.var2" :group-list="simpleWorkflowVarList"></tree-select>
    </div>
    <div class="contentItem" v-if="['DATE', 'LOCATION'].includes(tempNodeData.calcType)">
      <div class="itemTitle">
        计算单位
        <span class="require-flag">*</span>
      </div>
      <NormalSelect
        class="item-select"
        size="normal"
        :selectList="tempNodeData.calcType === 'DATE' ? dateUnitTypes : locationUnitTypes"
        :selectedItem.sync="tempNodeData.calcUnit"
      ></NormalSelect>
    </div>
    <div class="contentItem" v-if="tempNodeData.calcType !== 'NUM'">
      <div class="itemTitle">
        转换单位
        <span class="require-flag">*</span>
      </div>
      <NormalSelect
        class="item-select"
        size="normal"
        :selectList="tempNodeData.calcType === 'DATE' ? dateUnitTypes : locationUnitTypes"
        :selectedItem.sync="tempNodeData.unit"
      ></NormalSelect>
    </div>
    <div class="contentItem">
      <div class="itemTitle">小数</div>
      <el-input-number
        class="item-select"
        v-model="tempNodeData.decimal"
        :step="1"
        :min="0"
        :max="10"
      ></el-input-number>
    </div>
  </div>
</template>

<script>
import { deepClone, replaceAll } from "@/utils/common"
import {
  calcTypes,
  dateUnitTypes,
  locationUnitTypes
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import { canCalcFieldTypes } from "~/data/sheet"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import CalcTextarea from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/calc-textarea"
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import { bfs } from "@/utils/algorithm"
import { filterTreeVarGroup, transOldExpr } from "@/utils/workFlow"

export default {
  name: "setNumCompute",
  components: { TreeSelect, NormalSelect, CalcTextarea, GroupDropdownMenu },
  props: {
    workflowVarGroup: Array,
    nodeData: Object,
    extra: Object
  },
  data() {
    return {
      calcTypes,
      dateUnitTypes,
      locationUnitTypes,
      canCalcFieldTypes,
      tempNodeData: {},
      width: "300"
    }
  },
  mounted() {
    this.width = this.$el.getBoundingClientRect().width + ""
  },
  computed: {
    simpleWorkflowVarList() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) =>
          this.tempNodeData.calcType === "DATE"
            ? control?._type === "time"
            : control?._type === "location"
      })
    },
    workFlowInfo() {
      let map = {}
      bfs({
        arr: this.simpleWorkflowVarList,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    },
    numWorkflowVarList() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) =>
          this.canCalcFieldTypes.includes(control?._type) ||
          (control?._type === "calc" && control?.calcType !== "NUM")
      })
    },
    canCalcFields() {
      let result = []
      bfs({
        arr: this.numWorkflowVarList,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option =>
            result.push({
              label: option.label,
              value: option.value,
              regStr: option.value
            })
          )
        }
      })
      return result
    }
  },
  created() {
    this.initTempNode()
  },
  methods: {
    initTempNode() {
      this.tempNodeData = deepClone(this.nodeData)
      if (this.tempNodeData.calcType === "NUM") {
        let expression = this.tempNodeData.expression
        if (!expression.includes("dealObj")) {
          for (let item of this.canCalcFields) {
            // 去除 dealObj({XXX})包裹的函数部分
            let oldStr = item.regStr.substring(9, item.regStr.length - 2)
            expression = replaceAll(
              expression,
              oldStr,
              `<div data-value="${encodeURIComponent(item.value)}">${item.label}</div> `
            )
          }
          this.tempNodeData.expression = expression
        }
      } else {
        this.tempNodeData.var1 = transOldExpr(this.tempNodeData.var1)
        this.tempNodeData.var2 = transOldExpr(this.tempNodeData.var2)
      }
    },
    change(calcType) {
      if (calcType === "NUM") {
        this.tempNodeData.expression = ""
      } else {
        this.tempNodeData.var1 = ""
        this.tempNodeData.var2 = ""
      }
      this.tempNodeData.unit = ""
    },
    // 计算字段中插入可计算的字段
    selectCalcField(item) {
      this.$refs.calcTextarea.insertItem(item)
    },
    async submit() {
      let { calcType, expression, var1, var2, calcUnit, unit } = this.tempNodeData
      if (!calcType) return Promise.reject("请选择计算类型")
      let description
      if (calcType === "NUM") {
        let { result, msg } = this.$refs.calcTextarea.getOutputText()
        if (!result) return Promise.reject(msg)
        expression = msg
        // 处理description
        description = msg
        for (let item of this.canCalcFields) {
          description = description.replaceAll(item.regStr, ` ${item.label} `)
        }
      } else {
        if (!var1 || !var2) return Promise.reject("请填写计算表达式")
        if (!calcUnit) return Promise.reject("请选择计算单位")
        if (!unit) return Promise.reject("请选择转换单位")
        // 处理description
        description = `${this.workFlowInfo?.[this.tempNodeData.var1]} - ${
          this.workFlowInfo?.[this.tempNodeData.var2]
        }`
      }
      this.$set(this.extra, "description", { expression: description })
      return { calcType, expression, var1, var2, calcUnit, unit }
    }
  }
}
</script>

<style lang="scss">
.setNumCompute {
  .contentItem {
    overflow: hidden;
    .tree-select {
      width: 45%;
      float: left;
    }
  }
  .item-menu {
    top: 10px;
    position: relative;
  }
  .item-select {
    margin-top: 10px;
  }
}
</style>
